import { CASH_OUT_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'

export default {
	[CASH_OUT_MODULE_ID]: {
		moduleType: 'static',
		staticPageType: 'cashOut',
	},
}
